import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  api_request,
  downloadFileCommon,
} from "../../store/actions/commonAction";
import {
  API_METHOD_GET,
  API_METHOD_POST,
  API_METHOD_PUT,
  ENTITY_STATUS,
} from "../../config/constants";
import {
  CREATE_USER_ERROR,
  CREATE_USER_SUCCESS,
  FETCH_USERS_ERROR,
  FETCH_USERS_SUCCESS,
  SET_ADMIN_REDUCER,
  UPDATE_USER_ERROR,
  UPDATE_USER_SUCCESS,
} from "../../store/types/adminTypes";
import CoreDataTable from "../../core/dataDisplay/datatable/CoreDataTable";
import {
  Box,
  Grid,
  Icon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import CoreModal from "../../core/layouts/CoreModal";
import moment from "moment-timezone";
import { theme } from "../../config/theme";
import Swal from "sweetalert2";
import CoreInput from "../../core/inputs/CoreInput";
import CoreButtonContainer from "../../core/layouts/CoreButtonContainer";
import CoreContainedButton from "../../core/inputs/CoreContainedButton";
import CoreAutoComplete from "../../core/inputs/CoreAutoComplete";
import {
  DELETE_TABLE_DATA_ERROR,
  DELETE_TABLE_DATA_SUCCESS,
  FETCH_PERMISSION_TABLE_ERROR,
  FETCH_PERMISSION_TABLE_SUCCESS,
  FETCH_TABLE_DATA_ERROR,
  FETCH_TABLE_DATA_SUCCESS,
  FETCH_USER_PERMISSION_TABLE_ERROR,
  FETCH_USER_PERMISSION_TABLE_SUCCESS,
  INSERT_TABLE_DATA_ERROR,
  INSERT_TABLE_DATA_SUCCESS,
  UPDATE_TABLE_DATA_ERROR,
  UPDATE_TABLE_DATA_SUCCESS,
} from "../../store/types/manageDataTypes";
import CoreButton from "../../core/inputs/CoreButton";
import { setManageDataReducer } from "../../store/actions/manageDataAction";
import CoreIconButton from "../../core/inputs/CoreIconButton";
import CoreH4 from "../../core/dataDisplay/CoreH4";
import CoreH5 from "../../core/dataDisplay/CoreH5";
import CoreDatePicker from "../../core/inputs/CoreDatePicker";
import NewUser from "./UserOperations/NewUser";

export default function Users() {
  const users = useSelector((state) => state.admin.users);
  const updateUserSuccess = useSelector(
    (state) => state.admin.updateUserSuccess,
  );
  const updateUserError = useSelector((state) => state.admin.updateUserError);

  const tableData = useSelector((state) => state?.manageData?.tableData);

  const permissionTable = useSelector(
    (state) => state?.manageData?.permissionTable,
  );
  const userPermissionTable = useSelector(
    (state) => state?.manageData?.userPermissionTable,
  );

  const insertTableDataSuccess = useSelector(
    (state) => state?.manageData?.insertTableDataSuccess,
  );
  const insertTableDataError = useSelector(
    (state) => state?.manageData?.insertTableDataError,
  );
  const insertTableDataMsg = useSelector(
    (state) => state?.manageData?.insertTableDataMsg,
  );

  const updateTableDataSuccess = useSelector(
    (state) => state?.manageData?.updateTableDataSuccess,
  );
  const updateTableDataError = useSelector(
    (state) => state?.manageData?.updateTableDataError,
  );
  const updateTableDataMsg = useSelector(
    (state) => state?.manageData?.updateTableDataMsg,
  );

  const deleteTableDataSuccess = useSelector(
    (state) => state?.manageData?.deleteTableDataSuccess,
  );
  const deleteTableDataError = useSelector(
    (state) => state?.manageData?.deleteTableDataError,
  );
  const deleteTableDataMsg = useSelector(
    (state) => state?.manageData?.deleteTableDataMsg,
  );

  const createUserSuccess = useSelector(
    (state) => state?.admin?.createUserSuccess,
  );
  const createUserError = useSelector((state) => state?.admin?.createUserError);
  const createUserMsg = useSelector((state) => state?.admin?.createUserMsg);

  const [open, setModal] = useState(false);
  const [devices, setdevices] = useState([]);
  const [modalType, setModalType] = useState("user");
  const [invCount, setInvCount] = useState(0);
  const [userId, setUser] = useState(null);
  const [tableId, setTableId] = useState(new Date().getTime());

  const [selectedUser, setSelectedUser] = useState(null);

  const [selectedPermission, setSelectedPermission] = useState(null);
  const [startDate, setStartDate] = useState(
    moment().subtract(5, "days").format("DD-MM-YYYY"),
  );
  const [endDate, setEndDate] = useState(moment().format("DD-MM-YYYY"));
  const [errorMsg, setErrorMsg] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    getRoles();
    getPermissions();
  }, []);

  useEffect(() => {
    setModal(false);
    dispatch({
      type: SET_ADMIN_REDUCER,
      payload: {
        updateUserSuccess: false,
        updateUserError: false,
      },
    });
  }, [updateUserSuccess]);

  useEffect(() => {
    if (insertTableDataSuccess) {
      setTableId(new Date().getTime());
      dispatch(setManageDataReducer({ insertTableDataSuccess: false }));
      getUserPermissions(selectedUser?.id);
    }
    if (insertTableDataError) {
      dispatch(setManageDataReducer({ insertTableDataError: false }));
      Swal.fire({
        title: "Oops!",
        text: insertTableDataMsg,
        icon: "error",
        confirmButtonColor: theme.palette.primary.main,
      });
    }
  }, [insertTableDataSuccess, insertTableDataError]);

  useEffect(() => {
    if (updateTableDataSuccess) {
      setTableId(new Date().getTime());
      setModal(false);
      dispatch(setManageDataReducer({ updateTableDataSuccess: false }));
      Swal.fire({
        title: "Success",
        text: updateTableDataMsg,
        icon: "success",
        confirmButtonColor: theme.palette.primary.main,
      });
      dispatch(
        api_request(
          API_METHOD_GET,
          "/business/all/Users",
          {},
          null,
          null,
          FETCH_USERS_SUCCESS,
          FETCH_USERS_ERROR,
          true,
          false,
        ),
      );
    }
    if (updateTableDataError) {
      setModal(false);
      Swal.fire({
        title: "Error",
        text: updateTableDataMsg,
        icon: "error",
        confirmButtonColor: theme.palette.primary.main,
      });
      dispatch(setManageDataReducer({ updateTableDataError: false }));
    }
  }, [updateTableDataSuccess, updateTableDataError]);

  useEffect(() => {
    if (deleteTableDataSuccess) {
      setTableId(new Date().getTime());
      dispatch(setManageDataReducer({ deleteTableDataSuccess: false }));
      getUserPermissions(selectedUser?.id);
    }
    if (deleteTableDataError) {
      dispatch(setManageDataReducer({ deleteTableDataError: false }));
      Swal.fire({
        title: "Oops!",
        text: deleteTableDataMsg,
        icon: "error",
        confirmButtonColor: theme.palette.primary.main,
      });
    }
  }, [deleteTableDataSuccess, deleteTableDataError]);

  useEffect(() => {
    if (createUserSuccess) {
      dispatch({
        type: SET_ADMIN_REDUCER,
        payload: {
          createUserSuccess: false,
          createUserError: false,
          createUserMsg: "",
        },
      });
      setTableId(new Date().getTime());
      setModal(false);
    }
    if (createUserError) {
      setErrorMsg(createUserMsg);
      dispatch({
        type: SET_ADMIN_REDUCER,
        payload: {
          createUserSuccess: false,
          createUserError: false,
          createUserMsg: "",
        },
      });
    }
  }, [createUserSuccess, createUserError]);

  const getRoles = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        `/data/Roles`,
        {},
        {},
        null,
        FETCH_TABLE_DATA_SUCCESS,
        FETCH_TABLE_DATA_ERROR,
        true,
        false,
        true,
      ),
    );
  };

  const getPermissions = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        `/data/Permissions`,
        {},
        {},
        null,
        FETCH_PERMISSION_TABLE_SUCCESS,
        FETCH_PERMISSION_TABLE_ERROR,
        true,
        false,
        true,
      ),
    );
  };

  const getUserPermissions = (userId) => {
    dispatch(
      api_request(
        API_METHOD_GET,
        `/data/UserPermissions`,
        {},
        { userId },
        null,
        FETCH_USER_PERMISSION_TABLE_SUCCESS,
        FETCH_USER_PERMISSION_TABLE_ERROR,
        true,
        false,
        true,
      ),
    );
  };

  const onDeactivate = (row) => {
    if (!row.isActive || row._status === ENTITY_STATUS.inactive) {
      alert("Already deactive");
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "You want to deactivate the user",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: theme.palette.primary.main,
      icon: "warning",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed)
        dispatch(
          api_request(
            API_METHOD_PUT,
            "/user/" + row.id + "/deactivate",
            {},
            {
              //   _defaultFilter: encodeURIComponent(
              //     JSON.stringify({ createdBy: uid })
              //   ),
            },
            null,
            UPDATE_USER_SUCCESS,
            UPDATE_USER_ERROR,
            true,
            false,
          ),
        );
    });
  };

  const onActivate = (row) => {
    if (row.isActive || row._status === ENTITY_STATUS.active) {
      alert("Already active");
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "You want to activate the user",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: theme.palette.primary.main,
      icon: "warning",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed)
        dispatch(
          api_request(
            API_METHOD_PUT,
            "/user/" + row.id + "/activate",
            {},
            {
              //   _defaultFilter: encodeURIComponent(
              //     JSON.stringify({ createdBy: uid })
              //   ),
            },
            null,
            UPDATE_USER_SUCCESS,
            UPDATE_USER_ERROR,
            true,
            false,
          ),
        );
    });
  };

  const viewDevices = (row) => {
    setModalType("user");
    setdevices(row?.SessionManagers);
    setModal(true);
  };

  const updateInvoiceCount = (row) => {
    setModalType("invoice");
    setInvCount(row?.Person?.remainingInvoice);
    setModal(true);
    setUser(row.id);
  };

  const saveInvoiceCount = () => {
    dispatch(
      api_request(
        API_METHOD_PUT,
        "/user/" + userId + "/update/invoice",
        { count: invCount },
        {
          //   _defaultFilter: encodeURIComponent(
          //     JSON.stringify({ createdBy: uid })
          //   ),
        },
        null,
        UPDATE_USER_SUCCESS,
        UPDATE_USER_ERROR,
        true,
        false,
      ),
    );
  };

  const onAssignRole = (e) => {
    e.preventDefault();
    dispatch(
      api_request(
        API_METHOD_PUT,
        `/data/Users/${selectedUser?.id}/update`,
        { roleId: selectedUser?.roleId },
        null,
        null,
        UPDATE_TABLE_DATA_SUCCESS,
        UPDATE_TABLE_DATA_ERROR,
        true,
        false,
        true,
      ),
    );
  };

  const onAddPermission = (e) => {
    e.preventDefault();
    dispatch(
      api_request(
        API_METHOD_POST,
        `/data/UserPermissions/insert`,
        { userId: selectedUser?.id, permissionId: selectedPermission },
        null,
        null,
        INSERT_TABLE_DATA_SUCCESS,
        INSERT_TABLE_DATA_ERROR,
        true,
        false,
        true,
      ),
    );
  };

  const onDelete = (id) => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/data/UserPermissions/delete",
        { tableIds: [id] },
        null,
        null,
        DELETE_TABLE_DATA_SUCCESS,
        DELETE_TABLE_DATA_ERROR,
        true,
        false,
        true,
      ),
    );
  };

  const onDownloadUsage = () => {
    dispatch(
      downloadFileCommon({
        fileName: "usage-" + startDate + "-" + endDate,
        query: {},
        body: {
          userId: selectedUser?.id,
          startDate: moment(startDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
          endDate: moment(endDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
        },
        path: "/usage/admin/download",
      }),
    );
    setModalType("");
    setModal(false);
  };

  const onCreateNewUser = (values, action) => {
    console.log("onCreateNewUser", action, values);
    setErrorMsg(null);
    dispatch(
      api_request(
        API_METHOD_POST,
        "/user/create",
        values,
        null,
        null,
        CREATE_USER_SUCCESS,
        CREATE_USER_ERROR,
        true,
        false,
        true,
      ),
    );
  };

  return (
    <Box style={{ width: "100%" }}>
      <CoreModal
        width={"550px"}
        title={
          modalType === "invoice"
            ? "Update invoice"
            : modalType === "userRole"
              ? "User Role"
              : modalType === "userPermission"
                ? "User Permission"
                : modalType === "usage"
                  ? "Usage"
                  : modalType === "newUser"
                    ? "Create User"
                    : "Devices"
        }
        open={open}
        handleClose={() => {
          setModal(false);
        }}
      >
        <Box
          style={{
            height: 300,
            minHeight: 300,
            maxHeight: 300,
            overflowY: "scroll",
          }}
        >
          {modalType === "user" ? (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Last Login</TableCell>
                  <TableCell>Device</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {devices?.map((session) => (
                  <TableRow>
                    <TableCell>
                      {moment(session.updatedAt)
                        .tz("Asia/Kolkata")
                        .format("DD-MM-YYYY HH:MM")}
                    </TableCell>
                    {session.extraInfo ? (
                      <TableCell>
                        {session.extraInfo?.os?.name +
                          "-" +
                          session.extraInfo?.os?.version}
                        {", " + session.extraInfo?.client?.name}
                        <br />
                        {session.extraInfo?.device?.type === "desktop"
                          ? "desktop"
                          : session.extraInfo?.device?.brand +
                            "-" +
                            session.extraInfo?.device?.model}
                      </TableCell>
                    ) : (
                      <TableCell></TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : modalType === "userRole" ? (
            <>
              {tableData && (
                <Box sx={{ p: 1 }}>
                  <CoreAutoComplete
                    options={tableData?.map((item) => {
                      return { value: item?.id, label: item?.role };
                    })}
                    value={selectedUser?.roleId}
                    onChange={(id, value) => {
                      setSelectedUser({
                        ...selectedUser,
                        roleId: value?.value,
                      });
                    }}
                    label="Role"
                  />
                  <CoreButtonContainer>
                    <CoreButton onClick={onAssignRole}>Submit</CoreButton>
                  </CoreButtonContainer>
                </Box>
              )}
            </>
          ) : modalType === "userPermission" ? (
            <>
              <Grid container>
                <Grid xs={10}>
                  <CoreAutoComplete
                    label="Permission"
                    value={selectedPermission}
                    options={permissionTable.map((item) => {
                      return {
                        value: item?.id,
                        label: item?.name,
                      };
                    })}
                    onChange={(id, value) => {
                      setSelectedPermission(value?.value);
                    }}
                  />
                </Grid>
                <Grid xs={2}>
                  <CoreButton onClick={onAddPermission}>Add</CoreButton>
                </Grid>
                {userPermissionTable && (
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Action</TableCell>
                        <TableCell>Permission</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {userPermissionTable
                        ?.filter((f) => f.userId === selectedUser?.id)
                        ?.map((item) => (
                          <TableRow>
                            <TableCell>
                              <Tooltip title="Delete">
                                <CoreIconButton
                                  size="small"
                                  color="error"
                                  onClick={() => {
                                    onDelete(item.id);
                                  }}
                                >
                                  <Icon style={{ fontSize: "20px" }}>
                                    delete
                                  </Icon>
                                </CoreIconButton>
                              </Tooltip>
                            </TableCell>
                            <TableCell>
                              {
                                permissionTable?.find(
                                  (f) => f.id === item?.permissionId,
                                )?.name
                              }
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                )}
              </Grid>
            </>
          ) : modalType === "usage" ? (
            <Box>
              <Box style={{ display: "flex", justifyContent: "space-evenly" }}>
                <CoreDatePicker
                  value={startDate}
                  onChange={(val) => setStartDate(val)}
                  label="Start Date"
                />
                <CoreDatePicker
                  value={endDate}
                  onChange={(val) => setEndDate(val)}
                  label="End Date"
                />
              </Box>
              <CoreButtonContainer>
                <CoreContainedButton onClick={onDownloadUsage}>
                  Download
                </CoreContainedButton>
              </CoreButtonContainer>
            </Box>
          ) : modalType === "newUser" ? (
            <NewUser
              handleSubmit={onCreateNewUser}
              roles={tableData?.map((item) => {
                return { value: item?.id, label: item?.role };
              })}
              errorMsg={errorMsg}
            />
          ) : (
            <Box>
              <Box style={{ marginTop: 16 }}>
                <CoreInput
                  type="number"
                  label={"Invoice Count"}
                  value={invCount}
                  onChange={(event) => {
                    setInvCount(event?.target.value);
                  }}
                />
              </Box>
              <CoreButtonContainer>
                <CoreContainedButton onClick={saveInvoiceCount}>
                  Update
                </CoreContainedButton>
              </CoreButtonContainer>
            </Box>
          )}
        </Box>
      </CoreModal>

      <Box style={{ padding: 8 }}>
        <CoreH5>User Management</CoreH5>
        <CoreDataTable
          id="userList"
          key={tableId}
          showToolbar={true}
          // dense={true}
          searchable={true}
          noOfRows={10}
          apiDetails={{
            method: API_METHOD_GET,
            path: "/business/all/UserList",
            successType: FETCH_USERS_SUCCESS,
            errorType: FETCH_USERS_ERROR,
            authorized: true,
            searchKey: "email",
          }}
          rows={users || []}
          actions={[
            {
              icon: "add",
              onClick: () => {
                setModal(true);
                setModalType("newUser");
              },
            },
          ]}
          rowActions={[
            {
              title: "Download Usage",
              icon: "download",
              onClick: (row) => {
                setSelectedUser(row);
                setModalType("usage");
                setModal(true);
              },
            },
            {
              title: "Update Invoice count",
              icon: "update",
              onClick: updateInvoiceCount,
            },
            { title: "View devices", icon: "devices", onClick: viewDevices },
            { title: "Deactivate", icon: "delete", onClick: onDeactivate },
            { title: "Activate", icon: "check", onClick: onActivate },
            {
              title: "Role",
              icon: "person",
              onClick: (row) => {
                setSelectedUser(row);
                setModalType("userRole");
                setModal(true);
              },
            },
            {
              title: "Permissions",
              icon: "add_moderator",
              onClick: (row) => {
                getUserPermissions(row.id);
                setSelectedUser(row);
                setModalType("userPermission");
                setModal(true);
              },
            },
          ]}
          columns={[
            {
              view: (row) => {
                return row.id;
              },
              name: "id",
              label: "Id",
              width: 50,
            },
            {
              view: (row) => {
                return row?.SessionManagers && row.SessionManagers[0]
                  ? moment(row.SessionManagers[0].updatedAt)
                      .tz("Asia/Kolkata")
                      .format("DD-MM-YYYY HH:MM")
                  : "";
              },
              name: "lastLogin",
              label: "Last Login",
              width: 100,
            },
            {
              view: (row) => {
                return row._status;
              },
              name: "_status",
              label: "_status",
              width: 50,
            },
            {
              view: (row) => {
                return row.email;
              },
              name: "email",
              label: "Email",
              width: 200,
            },
            {
              view: (row) => {
                let str = "";
                if (row?.Person?.firstName) {
                  str += row?.Person?.firstName;
                }
                if (row?.Person?.middleName) {
                  str += " " + row?.Person?.middleName;
                }
                if (row?.Person?.lastName) {
                  str += " " + row?.Person?.lastName;
                }
                return str;
              },
              name: "Name",
              label: "Name",
              width: 100,
            },
            {
              view: (row) => {
                return row?.Role?.role;
              },
              name: "Role",
              label: "Role",
              width: 150,
            },
            {
              view: (row) => {
                return row?.Person?.remainingInvoice;
              },
              name: "Token",
              label: "Token",
              width: 50,
            },
            {
              view: (row) => {
                return row?.SessionManagers?.length;
              },
              name: "activeDevices",
              label: "Devices",
              width: 50,
            },
          ]}
          noUserFilter={true}
          selectable={false}
        />
      </Box>
    </Box>
  );
}
